var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasLoaded && _vm.user && _vm.data
    ? _c("iframe", {
        staticClass: "adl-ad",
        attrs: {
          src: _vm.data.ad_url,
          width: _vm.data.width,
          height: _vm.data.height,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }